export const SectionIntro = ({ children }: { children: React.ReactNode }) => (
    <div className="max-w-[580px] mr-auto ml-0 mt-[30px] mb-[65px]">{children}</div>
);
